import { SnackbarProvider } from 'notistack';

import CustomSnackbar from '@/components/CustomSnackbar';
import { useSettingsStore } from '@/store/useSettingsStore';

export function NotistackProvider() {
  const direction = useSettingsStore((s) => s?.settings?.direction);
  return (
    <SnackbarProvider
      anchorOrigin={{
        vertical: 'top',
        horizontal: direction === 'rtl' ? 'left' : 'right',
      }}
      autoHideDuration={2000} // Set duration to 2 seconds
      maxSnack={3}
      preventDuplicate
      Components={{
        success: CustomSnackbar,
        error: CustomSnackbar,
      }}
    />
  );
}
